import { ExternalDocumentType } from "../../../../../../../Wrap/Models/Domains/Documents/ExternalDocumentType";

export const ExternalDocumentTypeMapper = {
    [ExternalDocumentType.FundFactSheets]: "Fund Fact Sheets",
    [ExternalDocumentType.KiidDocuments]: "KIID/Simplified Prospectus",
    [ExternalDocumentType.KidDocuments]: "Investment Key Information Document",
    [ExternalDocumentType.SummaryBoxes]: "Cash Deposit Product Information Sheets",
    [ExternalDocumentType.FscsSheets]: "FSCS Information Documents",
    [ExternalDocumentType.BondsmithTermsAndConditions]: "Terms and Conditions",
};

export enum IllustrationType {
    GiaIllustration,
    IsaIllustration,
    PensionIllustration,
    WrapCashIllustration,
}

export const BWAMessages = {
    BWACheckMessage:
        "Please check the details on the payments in and or withdrawals step if you want to authenticate the bank account as part of this process.Please Note - Bank accounts must be verified to enable any withdrawals or income to be paid. If you have chosen to set up any payments in or out with the bank account(s) included we may require further evidence to process this request.",
    BWAValidationMessage: "Please select a different bank account for your payments in.",
};
